<template>
  <div>
    <h3>{{ $t('contact.list.previous') }}</h3>
    <el-table
      :data="contacts"
      :empty-text="$t('contact.list.empty')"
      :default-sort = "{prop: 'date', order: 'descending'}"
      style="width: 100%">
      <el-table-column
        prop="date"
        :label="$t('contact.list.date')"
        :formatter="formatDate"
        width="100">
      </el-table-column>
      <el-table-column
        prop="type"
        :label="$t('contact.list.type')"
        :formatter="formatType"
        width="180">
      </el-table-column>
      <el-table-column
        prop="message"
        :label="$t('contact.list.message')">
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'contactList',
  computed: {
    ...mapGetters({
      contacts: 'contactStore/contacts',
    }),
  },
  methods: {
    formatDate(row, column, cellValue) {
      const d = new Date(cellValue);
      const day = d.getDate() < 10 ? `0${d.getDate()}` : d.getDate();
      const month = d.getMonth() + 1 < 10 ? `0${d.getMonth() + 1}` : d.getMonth() + 1;
      const year = d.getFullYear();
      return `${day}/${month}/${year}`;
    },
    formatType(row, column, cellValue) {
      return this.$t(`contact.creation.form.type.${cellValue}`);
    },
  },
};
</script>

<style scoped lang="scss">

</style>
